function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Refresh Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14,0.7 C14.2761424,0.7 14.5,0.923857625 14.5,1.2 L14.5,5.2 C14.5,5.47614237 14.2761424,5.7 14,5.7 L10,5.7 C9.72385763,5.7 9.5,5.47614237 9.5,5.2 C9.5,4.92385763 9.72385763,4.7 10,4.7 L12.8655645,4.70198429 C12.8624099,4.69860874 12.8592919,4.69517999 12.8562116,4.6916981 C11.6314778,3.30729958 9.87809884,2.5004 7.9927,2.5004 C4.40662949,2.5004 1.4997,5.40675523 1.4997,8.9924 C1.4997,12.5782576 4.40684237,15.4854 7.9927,15.4854 C10.871272,15.4854 13.3819381,13.5952907 14.2063086,10.8829984 C14.2866117,10.6187901 14.5658934,10.4697055 14.8301016,10.5500086 C15.0943099,10.6303117 15.2433945,10.9095934 15.1630914,11.1738016 C14.2115578,14.3044781 11.3146001,16.4854 7.9927,16.4854 C3.85455763,16.4854 0.4997,13.1305424 0.4997,8.9924 C0.4997,4.85442624 3.85438896,1.5004 7.9927,1.5004 C10.114417,1.5004 12.0935339,2.38733325 13.5005816,3.9132833 L13.5,1.2 C13.5,0.923857625 13.7238576,0.7 14,0.7 Z",
  id: "refresh-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "refresh-Icon/Global/Refresh",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "refresh-Swatches/DarkGreen",
  transform: "translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "refresh-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#refresh-path-1"
})));

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.7bddc930.svg";
export { ForwardRef as ReactComponent };